export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const FORBIDDEN_URL = BASE_URL + 'forbidden';
export const KEYCLOAK_AUTH_URL = process.env.REACT_APP_KEYCLOAK_AUTH_URL;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

export const msalConfig = {
  appId: process.env.REACT_APP_MSAL_APP_ID ,
  tenantId: process.env.REACT_APP_MSAL_TENANT_ID ,
  scopes: ['user.read'],
};
